module.exports = __webpack_public_path__ + "static/img/at.27ec5a7f.svg";